import React, { useState } from 'react';
import {
  Chip,
  Popover,
  Box,
  TextField,
  Button,
} from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

import styles from './DateRangePickerStyles';

const SingleDatePicker = ({ date = '', setDate, label = 'Date' }) => {
  const [anchorPos, setAnchorPos] = useState(null);
  const [draftDate, setDraftDate] = useState(date);

  const openPopover = (e) => {
    setDraftDate(date);
    setAnchorPos({ top: e.clientY, left: e.clientX });
  };

  const closePopover = () => setAnchorPos(null);

  const applyDate = () => {
    setDate(draftDate);
    closePopover();
  };

  const clearDate = () => {
    setDraftDate('');
    setDate('');
    closePopover();
  };

  const formatDateLabel = () => date || `Select ${label}`;

  const isActive = Boolean(date);

  return (
    <>
      <Chip
        icon={<CalendarTodayIcon />}
        label={formatDateLabel()}
        onClick={openPopover}
        sx={isActive ? styles.activeChip : styles.chip}
      />

      <Popover
        open={!!anchorPos}
        anchorReference="anchorPosition"
        anchorPosition={anchorPos}
        onClose={closePopover}
      >
        <Box sx={styles.popoverContent}>
          <TextField
            label={label}
            type="date"
            value={draftDate || ''}
            onChange={(e) => setDraftDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />

          <Box sx={styles.dateApplyContainer}>
            <Button
              size="small"
              variant="text"
              onClick={clearDate}
              sx={styles.clearButton}
            >
              Clear
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={styles.dateApplyButton}
              onClick={applyDate}
            >
              Apply
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default SingleDatePicker;
